import {charts} from "../charts/charts.js";

export const chartStart = () => {
    const jsChart = document.querySelector('.js-chart');
    if (jsChart) {
        charts(false, jsChart);
        //jsChart.click();
    }
};